import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ReactComponent as SadFace } from './404.svg'
import { ReactComponent as NoNetwork } from './NoNetwork.svg'

import { StyledPage404, StyledNoItem, StyledNoNetwork } from './styled'

const PageNotFound = ({ type }) => {
	const [t] = useTranslation()

	switch(type) {
		case '404':
			return(
				<StyledPage404>
					<SadFace/>
					<div>
						<h1>404</h1>
						<h2>{t('common.strings.404')}</h2>
						<Link style={{ fontSize: '17px', marginTop: '10px' }} to='/'>{t('common.strings.back_to_homepage')}</Link>
					</div>
				</StyledPage404>
			)
		case 'NO_ITEM':
			return(
				<StyledNoItem>
					<p>{t('common.strings.404')}</p>
					<SadFace/>
				</StyledNoItem>
			)
		case 'ERROR':
			return(
				<StyledPage404 style={{
					height: 'calc(100vh - 40px)',
			    margin: '20px 0px',
			    borderRadius: 0
				}}>
					<SadFace/>
					<div>
						<h2 style={{ width: '240px' }}>{t('common.strings.site_error')}</h2>
						<Link style={{ fontSize: '17px', marginTop: '10px' }} onClick={() => window.location.reload()}>
							{t('common.strings.reload_page')}
						</Link>
					</div>
				</StyledPage404>
			)
		case 'NETWORK_ERROR':
			return(
				<StyledNoNetwork>
					<NoNetwork/>
					<h2>{t('common.strings.network_error')}</h2>
				</StyledNoNetwork>
			)
		default: return null
	}
}

PageNotFound.propTypes = {
	type: PropTypes.oneOf(['404', 'NO_ITEM', 'ERROR', 'NETWORK_ERROR'])
}

PageNotFound.defaultProps = {
	type: '404'
}

export default PageNotFound
